export interface UnidadeNegocio {
  id: string;
  nome: string;
  distribuidores: string[];
}

export interface Distribuidor {
  id: string;
  nome: string;
  unidadeNegocio: string;
  estado: string;
  cidades: string[];
}

export interface CidadeData {
  id: string;
  nome: string;
  estado: string;
  distribuidores: string[];
  coordenadas?: [number, number];
}

export const unidadesNegocio: UnidadeNegocio[] = [
  {
    id: 'unilever-pe',
    nome: 'unilever-pe',
    distribuidores: ['combomix-sp', 'g4-sp', 'playversal-mg'],
  },
  {
    id: 'unilever-ir',
    nome: 'unilever-ir',
    distribuidores: ['decminas-mg', 'ikeda-sp'],
  },
  {
    id: 'unilever-hc',
    nome: 'unilever-hc',
    distribuidores: ['combomix-sp', 'g4-sp'],
  },
  {
    id: 'unilever-bw',
    nome: 'unilever-bw',
    distribuidores: ['playversal-mg', 'decminas-mg'],
  },
];

export const distribuidores: Distribuidor[] = [
  {
    id: 'combomix-sp',
    nome: 'Combomix - Sp',
    unidadeNegocio: 'unilever-pe',
    estado: 'SP',
    cidades: ['São Paulo', 'Santos', 'Campinas', 'São José dos Campos'],
  },
  {
    id: 'g4-sp',
    nome: 'G4 Distribuidora - Sp',
    unidadeNegocio: 'unilever-pe',
    estado: 'SP',
    cidades: ['São Paulo', 'Campinas', 'Ribeirão Preto'],
  },
  {
    id: 'playversal-mg',
    nome: 'Playversal - Mg',
    unidadeNegocio: 'unilever-pe',
    estado: 'MG',
    cidades: [],
  },
  {
    id: 'decminas-mg',
    nome: 'Decminas - Mg',
    unidadeNegocio: 'unilever-ir',
    estado: 'MG',
    cidades: [],
  },
  {
    id: 'ikeda-sp',
    nome: 'Ikeda - Sp',
    unidadeNegocio: 'unilever-ir',
    estado: 'SP',
    cidades: ['Santos', 'São José dos Campos', 'Ribeirão Preto'],
  },
  {
    id: 'menon-rs',
    nome: 'Menon Sananduva - Rs',
    unidadeNegocio: 'unilever-hc',
    estado: 'RS',
    cidades: [],
  },
  {
    id: 'real-go',
    nome: 'Real - Go',
    unidadeNegocio: 'unilever-hc',
    estado: 'GO',
    cidades: [],
  },
  {
    id: 'mix-ba',
    nome: 'Mix - Ba',
    unidadeNegocio: 'unilever-bw',
    estado: 'BA',
    cidades: [],
  },
  {
    id: 'tt-pi',
    nome: 'Tt - Pi',
    unidadeNegocio: 'unilever-bw',
    estado: 'PI',
    cidades: [],
  },
  {
    id: 'riograndense-pb',
    nome: 'Riograndense - Pb',
    unidadeNegocio: 'unilever-pe',
    estado: 'PB',
    cidades: [],
  },
  {
    id: 'ludovico-sc',
    nome: 'Ludovico - Sc',
    unidadeNegocio: 'unilever-ir',
    estado: 'SC',
    cidades: [],
  },
];

export const cidades: CidadeData[] = [
  
];

export const estados = [
  { sigla: 'SP', nome: 'São Paulo', cidades: 5 },
  { sigla: 'MG', nome: 'Minas Gerais', cidades: 0 },
  { sigla: 'RJ', nome: 'Rio de Janeiro', cidades: 0 },
  { sigla: 'RS', nome: 'Rio Grande do Sul', cidades: 0 },
  { sigla: 'BA', nome: 'Bahia', cidades: 0 },
  { sigla: 'SC', nome: 'Santa Catarina', cidades: 0 },
  { sigla: 'GO', nome: 'Goiás', cidades: 0 },
  { sigla: 'PI', nome: 'Piauí', cidades: 0 },
  { sigla: 'PB', nome: 'Paraíba', cidades: 0 },
];

export function getDistribuidorStats() {
  return distribuidores.map(dist => ({
    unidadeNegocio: dist.nome,
    qtdeCidades: dist.cidades.length,
  }));
}

export function getCidadesByFilters(
  unidadeNegocio?: string,
  distribuidor?: string,
  estado?: string
): CidadeData[] {
  let filtered = [...cidades];

  if (estado && estado !== 'Todos') {
    filtered = filtered.filter(c => c.estado === estado);
  }

  if (distribuidor && distribuidor !== 'Todos') {
    const dist = distribuidores.find(d => d.nome === distribuidor);
    if (dist) {
      filtered = filtered.filter(c => dist.cidades.includes(c.nome));
    }
  }

  if (unidadeNegocio && unidadeNegocio !== 'Todos') {
    const un = unidadesNegocio.find(u => u.nome === unidadeNegocio);
    if (un) {
      const distIds = un.distribuidores;
      filtered = filtered.filter(c =>
        c.distribuidores.some(d => distIds.includes(d))
      );
    }
  }

  return filtered;
}
